import { AxiosRequestConfig } from 'axios'
import request from '..'
import {
  CreateWorkspacePayload,
  GetCxgWorkspaceResponse,
  JoinWorkspaceResponse,
  Workspace,
} from './workspace.type'

const getAllWorkspaces = async () => {
  const res = await request.get<ListResponse<Workspace>>('/v1/workspaces/all')

  return res.data.data
}

const getWorkspaceById = async (id?: string) => {
  if (!id) return

  try {
    const res = await request.get<DetailResponse<Workspace>>(`/v1/workspaces/${id}`, {
      raw: true,
      hideMessage: true,
    } as AxiosRequestConfig)

    return res.data.data
  } catch (error) {
    throw error
  }
}

const getCxgWorkspaceById = async (id?: string) => {
  if (!id) return

  try {
    const res = await request.get<DetailResponse<GetCxgWorkspaceResponse>>(
      `/v1/workspaces/cxg-workspace/${id}`
    )

    return res.data.data
  } catch (error) {
    throw error
  }
}

const createWorkspace = async (data: CreateWorkspacePayload) => {
  const res = await request.post<DetailResponse<Workspace>>('/v1/workspaces', data)

  return res.data.data
}

const joinWorkspace = async (id: string): Promise<JoinWorkspaceResponse | undefined> => {
  if (!id) return
  try {
    const res = await request.post<DetailResponse<JoinWorkspaceResponse>>(
      `/v1/workspaces/${id}/join`,
      {},
      { raw: true, hideMessage: true } as AxiosRequestConfig
    )

    return res.data.data
  } catch (error) {
    throw error
  }
}

const WorkspaceApi = {
  getAllWorkspaces,
  getWorkspaceById,
  getCxgWorkspaceById,
  createWorkspace,
  joinWorkspace,
}

export default WorkspaceApi
